export default __webpack_public_path__ + "static/shutterstock_2-5b22c427d6f72358558a5abc4bd087cf.jpg";